 <div class="sidebar" [class.collapsed]="collapsed">
  <div class="toggle-btn" (click)="toggleSidebar()">
    <mat-icon>{{ collapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
  </div>

  <div class="logo-container">
    <img src="assets/logo.svg" alt="Logo" class="logo-image" />
    <img src="assets/title.svg" alt="Title" class="title-image" />
  </div>

  <nav class="nav-links">
    <a routerLinkActive="active" class="nav-link" [routerLink]="['/admin/dashboard']">
      <mat-icon class="icon">speed</mat-icon>
      <span *ngIf="!collapsed">Dashboards</span>
    </a>

    <a routerLinkActive="active" class="nav-link" [routerLink]="['/admin/resource-database']">
      <mat-icon class="icon">build</mat-icon>
      <span *ngIf="!collapsed">Resource Database</span>
    </a>

    <a routerLinkActive="active" class="nav-link" [routerLink]="['/admin/statistics']">
      <mat-icon class="icon">bar_chart</mat-icon>
      <span *ngIf="!collapsed">Statistics</span>
    </a>
  </nav>
</div>
